// src/hooks/useInitializeApp.ts
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchClinicById } from "../store/slices/clinicSlice";
import { fetchAllDoctors } from "../store/slices/doctorSlice";
import { config } from "../config/environment";
import { RootState } from "../store";

export const useInitializeApp = () => {
  const dispatch = useAppDispatch();

  // You can optionally track initialization status
  const { currentClinic } = useAppSelector((state: RootState) => state.clinic);
  const { doctors } = useAppSelector((state: RootState) => state.doctors);

  useEffect(() => {
    // Initial data fetch
    const initializeData = async () => {
      try {
        // Fetch both clinic and doctors data concurrently
        await Promise.all([
          dispatch(fetchClinicById(config.clinic.id)).unwrap(),
          dispatch(fetchAllDoctors()).unwrap(),
        ]);
      } catch (error) {
        console.error("Error initializing app data:", error);
      }
    };

    initializeData();

    // Use this for polling for data updates
    //const pollingInterval = setInterval(() => {
    //  dispatch(fetchClinicById(config.clinic.id));
    //  dispatch(fetchAllDoctors());
    //}, 5 * 60 * 1000); // Every 5 minutes

    // Cleanup on unmount
    //return () => {
    //  clearInterval(pollingInterval);
    //};
  }, [dispatch]);

  // Optionally return initialization status
  return {
    isInitialized: Boolean(currentClinic && doctors.length > 0),
  };
};
